import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import companySlice from './slices/companySlice';
import superAdminSlice from './slices/superAdminSlice';
import projectSlice from './slices/projectSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    company: companySlice,
    superAdmin: superAdminSlice,
    project: projectSlice, // ✅ Added project slice
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

window.__REDUX_STORE__ = store;

export default store;
